module.exports = __webpack_public_path__ + "img/apple5.17a91b72.png";